"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        controls.comboboxTypeAheadFeature = "CLIComboboxTypeAheadFeature";
        /**
         * Framework class for ComboBox controls
         */
        var ComboBox = /** @class */ (function (_super) {
            __extends(ComboBox, _super);
            function ComboBox() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            ComboBox.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.$inputElement = this.$cachedElement.find("input");
                this.$lookupButton = this.$cachedElement.find(".lookupButton");
                this.isFocused = $dyn.observable(false);
                this.isExpanded = $dyn.observable(false);
                this.IsActive = $dyn.observable(false);
                var items = $dyn.value(this.Items);
                // Check to see if this.Items is an array, as it is also used as on object
                if (Array.isArray(items)) {
                    this.filteredItems = $dyn.observableArray(items);
                }
                this.previousIndex = -1;
                this.listShownIndex = $dyn.observable($dyn.value(this.shownIndex));
                this.ComboboxTypeAheadFeature = $dyn.computed(function () {
                    return _this.filteredItems && $dyn.util.isFlightEnabled($dyn.controls.comboboxTypeAheadFeature);
                });
                if (!$dyn.value(this.ComboboxTypeAheadFeature)) {
                    this.$inputElement.prop("readonly", true);
                    this.Shortcuts = $dyn.extendPrototype(this.Shortcuts, {
                        Backspace: {
                            // tslint:disable-next-line:only-arrow-functions
                            Handler: function () {
                                // Because this is not an editable text control, standard browser behavior for a backspace keydown is history.back()
                                // Prevent back navigation for input controls that the user could reasonably expect to type in on a case by case basis.
                                // Note: Type to select UX currently does not display what has been typed.  Backspace will not work when the user is typing to select.
                                // If the UX is changed to show the key strokes, this code will probably need to be updated or removed.
                                return true;
                            },
                            Keys: { keyCode: $dyn.ui.KeyCodes.backSpace },
                            RecordTelemetry: false,
                            ShowToUser: false,
                        }
                    });
                }
                if (!this.isInactiveCell()) {
                    $dyn.observe(this.isExpanded, function (value) {
                        if (value) {
                            _this.previousIndex = $dyn.value(_this.selectedIndex);
                            _this.listShownIndex(_this.previousIndex);
                            // Scroll into the view of the selected Item
                            // Wait until the flyout is displayed (IsActive is true)
                            _this.IsActive(false);
                            $dyn.observe(_this.IsActive, function (isActive) {
                                if (isActive) {
                                    window.setTimeout(function () {
                                        _this.selectedItemScrollIntoView(_this.previousIndex);
                                    });
                                    return false;
                                }
                                return true;
                            }, _this, undefined, true);
                            if (_this.$inputElement && _this.$inputElement.length) {
                                _this.$inputElement.attr("aria-activedescendant", _this.Id + "_list_item" + $dyn.value(_this.selectedIndex));
                                _this.$inputElement.focus();
                            }
                        }
                        else {
                            _this.previousIndex = -1;
                            if (_this.Root && _this.Root.isActiveControl && _this.Root.isActiveControl(_this.Name)) {
                                $dyn.microTask(function () {
                                    _this.$inputElement.focus();
                                });
                            }
                            if (_this.$inputElement && _this.$inputElement.length) {
                                _this.$inputElement.removeAttr("aria-activedescendant");
                            }
                        }
                    }, this, undefined, true);
                    $dyn.observe(this.listShownIndex, function (value) {
                        if ($dyn.value(_this.isExpanded) && $dyn.value(_this.IsActive)) {
                            _this.selectedItemScrollIntoView(value);
                            _this.$inputElement.attr("aria-activedescendant", _this.Id + "_list_item" + value);
                        }
                    });
                    this.flyoutClickSubscriber = function (options) {
                        // Don't close the flyout if a right-click was performed, or if the click came from the input tag, or if the click came within the flyout
                        // The input click and the item click will both handle closing the flyout
                        return !(options.isRightClick || _this.$inputElement.is(options.clickTarget) || $(options.clickTarget).parents(".comboBox-list").length);
                    };
                    this.flyoutEscapeSubscriber = function () {
                        if ($dyn.value(_this.isExpanded)) {
                            _this.SelectItem($dyn.value(_this.listShownIndex));
                        }
                    };
                    $dyn.observe(this.isFocused, function (value) {
                        if ($dyn.value(_this.AllowEdit)) {
                            if (value) {
                                _this.StatusIndicator($dyn.ui.StatusIndicator.none);
                            }
                            else {
                                _this.UpdateStatusArea();
                            }
                        }
                    });
                    $dyn.observe(this.AllowEdit, function (newValue) {
                        if ($dyn.value(_this.IsValid) && !newValue) {
                            var hasFocus_1 = $dyn.value(_this.isFocused);
                            _this.updatingBlock(function () {
                                if ($dyn.value(_this.isExpanded)) {
                                    _this.isExpanded(false);
                                }
                                if ($dyn.value(_this.shownItem) !== $dyn.value(_this.SelectedItem)) {
                                    _this.shownItem($dyn.value(_this.SelectedItem));
                                }
                                if (hasFocus_1) {
                                    _this.$inputElement.select();
                                }
                            });
                        }
                        if ($dyn.value(_this.Required)) {
                            _this.UpdateStatusArea();
                        }
                    });
                    $dyn.observe(this.Enabled, function (newValue) {
                        if ($dyn.value(_this.IsValid) && !newValue) {
                            var hasFocus_2 = $dyn.value(_this.isFocused);
                            _this.updatingBlock(function () {
                                if ($dyn.value(_this.isExpanded)) {
                                    _this.isExpanded(false);
                                }
                                if ($dyn.value(_this.shownItem) !== $dyn.value(_this.SelectedItem)) {
                                    _this.shownItem($dyn.value(_this.SelectedItem));
                                }
                                if (hasFocus_2 && _this.Root && _this.Root.element) {
                                    var tabbableElements = $(_this.Root.element).find(":tabbable");
                                    var index = tabbableElements.index(_this.$inputElement[0]);
                                    if (index > -1) {
                                        index = index % tabbableElements.length;
                                        tabbableElements.eq(index + 1).focus();
                                        tabbableElements.eq(index + 1).select();
                                    }
                                }
                            });
                        }
                        if ($dyn.value(_this.Required)) {
                            _this.UpdateStatusArea();
                        }
                    });
                }
            };
            ComboBox.prototype.getTaskGuideParams = function (options) {
                if (!this._isExpandedObserver) {
                    this._isExpandedObserver = $dyn.observe(this.isExpanded, function () {
                        if ($dyn.ax && $dyn.ax.taskGuide && $dyn.ax.taskGuide.repositionGuidedQtip && !$dyn.value($dyn.ax.taskGuide.repositionGuidedQtip)) {
                            $dyn.async(function () {
                                $dyn.ax.taskGuide.repositionGuidedQtip(true);
                            }, 0, "reset task guide qtip");
                        }
                    });
                }
                options = _super.prototype.getTaskGuideParams.call(this, options);
                var target = $(this.element);
                if ($dyn.value(this.isExpanded)) {
                    var flyoutDiv = $('.comboBox-list[data-dyn-lastvisible="true"]');
                    if (flyoutDiv && flyoutDiv.length === 1) {
                        target = flyoutDiv;
                    }
                }
                options.target = target;
                return options;
            };
            ComboBox.prototype.dispose = function () {
                if (this._isExpandedObserver) {
                    this._isExpandedObserver.dispose();
                    this._isExpandedObserver = null;
                }
                if (this.ComboboxTypeAheadFeature && this.ComboboxTypeAheadFeature.valueChanged) {
                    this.ComboboxTypeAheadFeature.valueChanged.clearAllDependencies();
                    this.ComboboxTypeAheadFeature = undefined;
                }
                _super.prototype.dispose.call(this);
            };
            /**
             * Checks items for an empty values (empty of space-only)
             * @returns True if there are empty (space-only) values; otherwise false
             */
            ComboBox.prototype.hasEmptyItems = function () {
                var items = $dyn.value(this.Items);
                if (items) {
                    return items.some(function (item) {
                        return item.Label.trim() === "";
                    });
                }
                else {
                    return false;
                }
            };
            /**
             * Select the index on click
             * @param index The index of the item that was clicked
             */
            ComboBox.prototype.clickedItem = function (index) {
                this.TelemetryOptions = { inputType: $dyn.telemetry.InputType.mouse };
                if ($dyn.value(this.ComboboxTypeAheadFeature)) {
                    this.SelectItem(index);
                }
                else {
                    this.isExpanded(false);
                    this.selectedIndex(index);
                }
            };
            /**
             * Click the lookup button when the input element is clicked
             */
            ComboBox.prototype.onInputClick = function () {
                if (this.allowUserChanges()) {
                    // Click the lookupButton so the flyout click handler is run
                    this.$lookupButton.click();
                }
            };
            /**
             * The focus in event handler
             */
            ComboBox.prototype.focusInCallBack = function () {
                this.isFocused(true);
            };
            /**
             * The focus out event handler
             * @param event The focus in event
             */
            ComboBox.prototype.focusOutCallBack = function (event) {
                var _this = this;
                this.updatingBlock(function () {
                    _this.isFocused(false);
                    var flyoutObject = $dyn.flyout.flyoutManager.getTopFlyout();
                    if (flyoutObject && flyoutObject.flyout && $dyn.value(flyoutObject.flyout) &&
                        $dyn.value(flyoutObject.flyout).length > 0 && event.relatedTarget !== $dyn.value(flyoutObject.flyout)[0]) {
                        if ($dyn.value(_this.ComboboxTypeAheadFeature)) {
                            _this.SelectItem($dyn.value(_this.listShownIndex));
                        }
                        else {
                            _this.isExpanded(false);
                        }
                    }
                });
            };
            /**
             * The keydown event handler
             * @param evt The keydown event
             */
            ComboBox.prototype.onKeyDown = function (evt) {
                $dyn.util.handleShortcuts(this, evt);
            };
            /** @obsolete */
            ComboBox.prototype.cellRenderer = function (rowIndex) {
                return {
                    value: this.SelectedItem && this.SelectedItem.virtualizer ? this.getItemLabelByIndex(this.SelectedItem.virtualizer(rowIndex)) : this.selectedLabel()
                };
            };
            ComboBox.prototype.attached = function () {
                _super.prototype.attached.call(this);
                this.$inputElement = this.$cachedElement.find("input");
                this.$lookupButton = this.$cachedElement.find(".lookupButton");
                this.isFocused = $dyn.observable(false);
                this.isExpanded = $dyn.observable(false);
                this.IsActive = $dyn.observable(false);
            };
            /**
             * The keydown handler for the Alt+Down shortcut
             * @param evt The keydown event
             * @returns false to prevent $dyn.util.handleShortcuts to stopPropagation/preventDefault
             */
            ComboBox.prototype.openDropDown = function (evt) {
                if (!$dyn.value(this.isExpanded) && this.allowUserChanges()) {
                    this.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                    this.isExpanded(true);
                    evt.preventDefault();
                    // Using stop immediate propagation to prevent typetoSelect keydown action
                    evt.stopImmediatePropagation();
                }
                return false;
            };
            /**
             * The keydown handler for when a tab or shift+tab is pressed
             */
            ComboBox.prototype.HandleTabOut = function () {
                if ($dyn.value(this.isExpanded)) {
                    this.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                    if ($dyn.value(this.ComboboxTypeAheadFeature)) {
                        this.SelectItem($dyn.value(this.listShownIndex));
                    }
                    else {
                        this.shownIndex($dyn.value(this.listShownIndex));
                        this.selectedIndex($dyn.value(this.shownIndex));
                        this.isExpanded(false);
                    }
                }
            };
            /**
             * Select the item corresponding to the index passed in
             * @param item The index of the item in the list to select
             */
            ComboBox.prototype.SelectItem = function (index) {
                if (this.filteredItems) {
                    var filteredItems = $dyn.value(this.filteredItems);
                    var items = $dyn.value(this.Items);
                    if (filteredItems.length === 0 || (items.length === filteredItems.length)) {
                        this.shownIndex(index);
                    }
                    else {
                        this.shownIndex(filteredItems[index].RealIndex);
                        this.filteredItems($dyn.value(this.Items));
                    }
                }
                if ($dyn.value(this.isExpanded)) {
                    this.isExpanded(false);
                }
                this.selectedIndex($dyn.value(this.shownIndex));
                this.$inputElement.val(this.selectedLabel());
            };
            /**
             * Scroll the specified index into view
             * @param itemIndex The index of the item to scroll into view
             */
            ComboBox.prototype.selectedItemScrollIntoView = function (itemIndex) {
                var $comboBoxList = $(document.body).find('.comboBox-list[data-dyn-lastvisible="true"]');
                var items = $dyn.value(this.Items);
                if ($comboBoxList.length > 0 && items.length > itemIndex && itemIndex >= 0) {
                    // Get the correct list item selector (ComboBox is listbox > option and ComboBoxPopup is list > listitem)
                    var itemSelector = $comboBoxList[0].getAttribute("role") === "listbox" ? "option" : "listitem";
                    var $selectedElement = $comboBoxList.find('li[role="' + itemSelector + '"]').eq(itemIndex);
                    if ($selectedElement.length > 0) {
                        $selectedElement[0].scrollIntoViewIfNeeded(false);
                    }
                }
            };
            return ComboBox;
        }(controls.EnumControl));
        controls.ComboBox = ComboBox;
        ComboBox.prototype.LookupButton = true;
        ComboBox.prototype.CanOpenLookupForm = false;
        // tslint:disable-next-line:no-string-literal
        ComboBox.prototype["$lookupButton"] = null;
        // tslint:disable:object-literal-sort-keys
        var comboBoxShortcuts = {
            Enter: {
                Keys: { keyCode: $dyn.ui.KeyCodes.enter },
                Handler: function () {
                    var stopPropagation = false;
                    if ($dyn.value(this.isExpanded)) {
                        this.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                        if ($dyn.value(this.ComboboxTypeAheadFeature)) {
                            this.SelectItem($dyn.value(this.listShownIndex));
                        }
                        else {
                            this.shownIndex($dyn.value(this.listShownIndex));
                            this.selectedIndex($dyn.value(this.shownIndex));
                            this.isExpanded(false);
                        }
                        stopPropagation = true;
                    }
                    return stopPropagation;
                },
                RecordTelemetry: false,
                ShowToUser: false,
            },
            AltDownToOpen: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.downArrow },
                Handler: function (evt) {
                    return this.openDropDown(evt);
                },
                RecordTelemetry: false,
                ShowToUser: function () { return this.allowUserChanges(); },
                Description: $dyn.label("Input_OpenDropDown")
            },
            TabOut: {
                Keys: { keyCode: $dyn.ui.KeyCodes.tab, isShiftKeyAgnostic: true },
                Handler: function () {
                    this.HandleTabOut();
                    return false;
                },
                RecordTelemetry: false,
                ShowToUser: false,
            },
        };
        ComboBox.prototype.Shortcuts = $dyn.extendPrototype(ComboBox.prototype.Shortcuts, comboBoxShortcuts);
        $dyn.adapter({ id: "ComboBoxSummary", controlType: "ComboBox", template: "SummaryField" });
        $dyn.adapter({ id: "ComboBoxCardCell", controlType: "ComboBox", template: "CardCell" });
        /**
         * Framework class for ComboBoxCell controls
         */
        var ComboBoxCell = /** @class */ (function (_super) {
            __extends(ComboBoxCell, _super);
            function ComboBoxCell(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                // All cells are editable (because allow edit is not virtualized)
                _this.AllowEdit = true;
                return _this;
            }
            Object.defineProperty(ComboBoxCell.prototype, "valueNow", {
                /**
                 * The current value in the control
                 */
                get: function () {
                    return parseInt(this.element.getAttribute("data-dyn-value"), 10);
                },
                set: function (value) {
                    // 0 is a valid value so can not do value ?
                    this.element.setAttribute("data-dyn-value", (value !== null && value !== undefined) ? value.toString() : "");
                    this.shownItem(this.valueNow);
                    this.$inputElement.val(this.selectedLabel());
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ComboBoxCell.prototype, "validating", {
                /**
                 * Whether or not the control is currently validating
                 */
                get: function () {
                    return $dyn.util.stringToBoolean(this.element.getAttribute("data-dyn-validating"));
                },
                set: function (value) {
                    // true is a valid value so can not do value ?
                    this.element.setAttribute("data-dyn-validating", (value !== null && value !== undefined) ? value.toString() : "");
                },
                enumerable: false,
                configurable: true
            });
            ComboBoxCell.prototype.clickedItem = function (index) {
                this.valueNow = index;
                this.isExpanded(false);
                this.RaiseEvent($dyn.ui.ChangeEvent, {
                    bubbles: true,
                });
            };
            ComboBoxCell.prototype.setSelectedIndex = function (newIndex) {
                if (this.allowUserChanges()) {
                    var items = $dyn.value(this.Items);
                    if (items.length > newIndex && newIndex >= 0) {
                        var newValue = items[newIndex].Value;
                        this.shownItem(newValue);
                        this.valueNow = typeof newValue === "number" ? newValue : parseInt(newValue, 10);
                        this.RaiseEvent($dyn.ui.ChangeEvent, {
                            bubbles: true,
                        });
                    }
                }
                var retVal = $.Deferred();
                retVal.resolve();
                return retVal;
            };
            /**
             * Implements the request popup flyout behavior
             * @param flyoutObservable The observable holding the flyout
             * @returns The jQuery wrapper of the flyout element
             */
            ComboBoxCell.prototype._requestPopup = function (flyoutObservable) {
                // Note: it might be desirable to have the ComboBox control use the same pattern as this.
                if (!this._flyout) {
                    this._flyout = $dyn.getTemplateInstance("ComboBoxPopup", "ul");
                    $dyn.dataBind(this._flyout[0], this);
                }
                flyoutObservable(this._flyout);
                return this._flyout;
            };
            ComboBoxCell.prototype.focusOutCleanup = function () {
                this.isExpanded(false);
            };
            ComboBoxCell.prototype.ApplyState = function (clientState) {
                if (clientState && clientState.shownItem !== null && clientState.shownItem !== undefined) {
                    var currentValue = this.valueNow;
                    // Update the formatted value if it's different from the one stored in the Client State on the server
                    // We should not do !== check here as valueNow is int and showIndex is string
                    // tslint:disable-next-line:triple-equals
                    if (clientState.shownItem != currentValue) {
                        this.valueNow = clientState.shownItem;
                    }
                }
                var retVal = $.Deferred();
                retVal.resolve();
                return retVal;
            };
            ComboBoxCell.prototype.GetState = function () {
                return {
                    messages: this.messages,
                    shownItem: this.valueNow
                };
            };
            ComboBoxCell.prototype.attached = function () {
                this._flyout = undefined;
                _super.prototype.attached.call(this);
                this.shownItem(this.valueNow);
            };
            return ComboBoxCell;
        }(ComboBox));
        controls.ComboBoxCell = ComboBoxCell;
        $dyn.cellAdapter({ id: "ComboBox", template: "ComboBoxCell" });
        $dyn.cellAdapter({ id: "ComboBox", controlType: "ComboBoxCell", template: "ComboBoxCellEditor", type: $dyn.cellTypes.editor });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ComboBox.js.map
